import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'minutesDiff',
    standalone: false,
})
export class MinutesDiffPipe implements PipeTransform {
    transform(
        fromDate: Date | string | null | undefined,
        toDate: Date | string | null | undefined
    ): number | undefined {
        if (fromDate == null || toDate == null) {
            return undefined;
        }

        const from = new Date(fromDate);
        const to = new Date(toDate);

        if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) {
            return undefined;
        }

        return (to.getTime() - from.getTime()) / 60000;
    }
}
